import { Reducer } from "redux"
import { HomeState, HomeActionTypes } from "./types";

// 初始化state
const initialState: HomeState = {
  appList: [],
  errors: undefined,
  loading: false,
  myCompanyList: [],
  loadingMyCompanyList: false,
  switchCompanyModal: false
};

// 申请开票列表页面reducer定义
const reducer: Reducer<HomeState> = (state = initialState, action) => {
  switch (action.type) {
    // 获取应用列表
    case HomeActionTypes.FETCH_APP_LIST: {
      return { ...state, loading: true };
    }
    case HomeActionTypes.FETCH_APP_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        appList: action.payload
      };
    }
    case HomeActionTypes.FETCH_APP_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }
    case HomeActionTypes.FETCH_PERSONAL_CERT_INFO:
      return {
        ...state
      }
    case HomeActionTypes.FETCH_PERSONAL_CERT_INFO_SUCCESS:
      return {
        ...state,
        myCertInfo: action.payload
      }
    case HomeActionTypes.FETCH_PERSONAL_CERT_INFO_ERROR:
      return {
        ...state
      }
    case HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST:
      return {
        ...state,
        myCompanyList: [],
        loadingMyCompanyList: true
      }
    case HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        myCompanyList: action.payload,
        loadingMyCompanyList: false
      }
    case HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST_ERROR:
      return {
        ...state,
        myCompanyList: [],
        loadingMyCompanyList: false
      }

    // 更新HomeState
    case HomeActionTypes.UPDATE_HOME_STATE: {
      return { 
        ...state,
        ...action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export { reducer as homeReducer }
